import { useEffect, useState } from 'react';
import AiDescriptionGenerator from '../../components/AiDescriptionGenerator';
import AnnonceVehiculeModal from '../../components/AnnonceVehiculeModal';
function CompleteAnnoncePage() {
  const [VehiculeData, setVehiculeData] = useState({});

  useEffect(() => {
    let fetchReviews = async () => {
      let datavehicule = window.localStorage.getItem('VehicleStorage');
      datavehicule = JSON.parse(datavehicule);
      setVehiculeData(datavehicule);
    };
    fetchReviews();
  }, []);

  return (
    <>
      <div className="mt-2 container col-md-4">
        <h1>Complètez votre annonce</h1>
        {VehiculeData?.id && <AiDescriptionGenerator vehicleId={VehiculeData.id} />}
        <div className="my-div  w-100 d-md-block w-md-75 ">
          <AnnonceVehiculeModal vehicule={VehiculeData}></AnnonceVehiculeModal>
        </div>
      </div>
    </>
  );
}

export default CompleteAnnoncePage;
